import Cookies from 'universal-cookie';

// Name of the OneTrust consent cookie
export const OPTANONCONSENT_COOKIE = 'OptanonConsent';
// Constant for the targeting consent group code
export const TARGETING_CONSENT_GROUP = 'C0004:1';

/**
 * Retrieves the value of a cookie by name.
 * Uses universal-cookie for cross-platform consistency (SSR/client).
 * @param {string} cookieName - The name of the cookie to retrieve.
 * @returns {string|null} The cookie value, or null if not found.
 */
export const getCookie = cookieName => {
  const cookies = new Cookies(
    typeof document !== 'undefined' ? document.cookie : null
  );
  return cookies.get(cookieName) || null;
};

/**
 * Returns true if user has opted in to targeting cookies (C0004:1)
 * by checking the 'groups' parameter in the OptanonConsent cookie.
 */
export const hasTargetingConsent = () => {
  // Get the value of the OptanonConsent cookie
  const consent = getCookie(OPTANONCONSENT_COOKIE);
  // Extract the 'groups' parameter from the cookie value
  const groups =
    consent &&
    new URLSearchParams(consent.replace(/&amp;/g, '&')).get('groups');
  // If groups exist, decode them (in case they're URL-encoded), split into an array,
  // and check if 'C0004:1' (targeting cookies) is present
  return groups
    ? decodeURIComponent(groups)
        .split(',')
        .includes(TARGETING_CONSENT_GROUP)
    : false;
};
